(function() {

	'use strict';
	angular.module('app').controller('ClientCompaniesController',
		function($scope, $routeParams, $location, ClientAccountListTableService, ClientGroupListTableService,
		        ClientLocationListTableService, ClientsListsRepositoryFactory, ClientService, $q, toastr) {

			$scope.params = $routeParams;
            $scope.companyId = angular.copy($scope.params.companyId);
			$scope.init = init;
			$scope.changeTab = changeTab;
			$scope.goTo = goTo;
			$scope.init = init;
			//$scope.getGroups = getGroups;
			//$scope.getAccounts = getAccounts;
			$scope.paginationData = {
				size: 20,
				page: 0,
				sort: 'id'
			};

			init();

			function init() {
				var promises = [];

				if ($scope.params.tab) {
					switch ($scope.params.tab) {
						case 'group':
							changeTab(1, 'group');
							break;
						case 'location':
							changeTab(2, 'location');
							break;
						case 'account':
							changeTab(3, 'account');
							break;
						default:
							changeTab(1, 'group');
							break;
					}
				}

				promises.push(getCompany($scope.params.companyId));
				//promises.push(getGroups($scope.paginationData));

				$q.all(promises).then(function() {
                    $scope.locationsTable = new ClientLocationListTableService($scope.companyId).tableData;
                    $scope.accountsTable = new ClientAccountListTableService($scope.companyId).tableData;
                    $scope.groupsTable = new ClientGroupListTableService($scope.companyId).tableData;
				});
			}

			function getCompany(companyId) {
				ClientService.Company.get(
					companyId,
					function(data) {
						$scope.company = data;
					},
					function(err) {
						console.log(err)
					})
			}
/*

			function getGroups(requestPagination, filters) {
				var requestData = {
					company: $scope.companyId
				};
				angular.extend(requestData, requestPagination, filters);
				ClientService.Group.getAll(function(data) {
					$scope.groupsTable = ClientGroupListTableService.buildTableData(data, requestPagination);
					ClientsListsRepositoryFactory.lists.groups = data;
				}, function(error) {
					toastr.error(error.message)
				}, requestData);
			};
*/

			function changeTab(index, tab) {
				$scope.activeIndex = index;
				$location.search({tab:tab});
			}

			function goTo(path, params) {
				$location.path(path).search(params);
			}
		});
})();



// WEBPACK FOOTER //
// ./js/controllers/client/ClientCompaniesController.js